import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import NotificationsNoneIcon from '@material-ui/icons/NotificationsOff'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(theme => ({
  notificationPlaceholderWrapper: {
    display: 'flex',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '85%',
    },
    height: '100%',
    flexDirection: 'column',
    color: '#ccc',
    textAlign: 'center',
    justifyContent: 'center',
    alignContent: 'center',
  },
  notificationPlaceholderIcon: {
    margin: 'auto',
    fontSize: 100,
    color: '#ccc'
  }
}))

const MessagePlaceholder = () => {
  const classes = useStyles()

  return (
    <div className={classes.notificationPlaceholderWrapper}>
      <div>
        <NotificationsNoneIcon className={classes.notificationPlaceholderIcon}  />
        <br/>
        <Typography style={{ fontSize: 16 }}>Você não possui mensagens.</Typography>
      </div>
    </div>
  )
}

export default MessagePlaceholder
